import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import './App.css';

// Import pages
import HomePage from './pages/HomePage';
import DetailPage from './pages/DetailPage';
import CompressPage from './pages/CompressPage';
import ResizePage from './pages/ResizePage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

// Import components
import AppHeader from './components/AppHeader';
import AppFooter from './components/AppFooter';
import { LanguageProvider } from './i18n/LanguageContext';

const { Content } = Layout;

function App() {
  return (
    <Router>
      <LanguageProvider>
        <Layout className="layout" style={{ minHeight: '100vh' }}>
          <AppHeader />
          <Content 
            style={{ padding: '0 50px', marginTop: 64 }}
            className="responsive-content"
          >
            <div className="site-layout-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/convert/:format" element={<DetailPage />} />
                <Route path="/compress/:type" element={<CompressPage />} />
                <Route path="/resize/:type" element={<ResizePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
              </Routes>
            </div>
          </Content>
          <AppFooter />
        </Layout>
      </LanguageProvider>
    </Router>
  );
}

export default App;
